import { keyframes, css } from 'styled-components'

const scaleDownIn = keyframes`
  from {
    transform: scale(1.4);
  }

  to {
    transform: scale(1);
  }
`

const animation = css`
  animation: ${scaleDownIn} 1s cubic-bezier(0.87, 0, 0.13, 1); /* easeInOutExpo */
`

export default animation
